import { Route, Routes } from "react-router-dom";
import Login from "./Login/Login";
import RegistrationForm from "./Login/RegistrationForm";
import BankDetailsForm from "./BankDetails/BankDetails";
import VerifyBank from "./BankDetails/VerifyBank";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import CreditApproval from "./Login/CreditApproval";
import CompleteKyc from "./KYC/CompleteKyc";
import KycSuccess from "./KYC/KycSuccess";
import RetriveBank from "./BankDetails/RetriveBank";
import TakeSelfie from "./PersonalDetails/TakeSeflie";
import Enach from "./Enach/Enach";
import EnachStatus from "./Enach/EnachStatus";
import AmountRequired from "./Login/AmountRequired";
import LoaderScreen from "./Login/LoaderScreen";
import AmountApproved from "./Login/AmountApproved";
import Occupation from "./BankDetails/Occupation";
import EmploymentDetails from "./EmploymentDetails/EmploymentDetails";
import BusinessDetails from "./BusinessDetails/BusinessDetails";
import References from "./EmploymentDetails/References";
import EnachCongratulations from "./Enach/Congratulations";
import ConsentCheck from "./BankDetails/ConsentCheck";
import WelcomeBack from "./Enach/WelcomeBack";
import FundsCongratulations from "./Enach/FundsCongratulations";
import FinalCongratulations from "./Enach/FinalCongratulations";
import EnachMandate from "./Enach/EnachMandate";
import ApplicationInProgress from "./Enach/ApplicationInProgress";
import ApplicationUnsuccessful from "./Enach/ApplicationUnsuccessful";
import LoanDetail from './LoanDetail/LoanDetail';
import LoadingScreen from "./LoadingScreen/LoadingScreen";
import RpdPollingScreen from "./RpdPollingScreen/RpdPollingScreen";
import UpiMandate from "./Enach/UpiMandate";
import Rejected from "./Enach/Rejected";
import CkycOtpInput from "./KYC/CkycOtp";
import VkycVerification from "./VkycVerification/VkycVerification";
import DisbursalWaiting from "./DisbursalWaiting/DisbursalWaiting";


function AppRouter() {
    //const [getRedirectionUrl] = useLazyGetRedirectionUrlQuery()
    return (
        <Routes>
            <Route path='/' element={<LoaderScreen />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<RegistrationForm />} />
            <Route path='/required-amount' element={<AmountRequired />} />
            <Route path='/approved-amount' element={<AmountApproved />} />
            <Route path='/credit-approval' element={<CreditApproval />} />
            <Route path='/personal-details' element={<PersonalDetails />} />
            <Route path='/complete-your-kyc' element={<CompleteKyc />} />
            <Route path='/kyc-success' element={<KycSuccess />} />
            <Route path='/verify-bank' element={<VerifyBank />} />
            <Route path='/retrive-bank' element={<RetriveBank />} />
            <Route path='/occupation' element={<Occupation />} />
            <Route path='/consent' element={<ConsentCheck />} />
            <Route path='/employment-details' element={<EmploymentDetails />} />
            <Route path='/references' element={<References />} />
            <Route path='/business-details' element={<BusinessDetails />} />
            <Route path='/bank-details' element={<BankDetailsForm />} />
            <Route path='/take-selfie' element={<TakeSelfie />} />
            <Route path='/enach' element={<Enach />} />
            <Route path='/final-approval' element={<EnachStatus />} />
            <Route path='/congratulations' element={<EnachCongratulations />} />
            <Route path='/funds-congratulations' element={<FundsCongratulations />} />
            <Route path='/final-congratulations' element={<FinalCongratulations />} />
            <Route path='/welcome-back' element={<WelcomeBack />} />
            <Route path='/application-in-progress' element={<ApplicationInProgress />} />
            <Route path='/application-unsuccessful' element={<ApplicationUnsuccessful />} />
            <Route path='/mandate' element={<EnachMandate />} />
            <Route path='/upi-mandate' element={<UpiMandate />} />
            <Route path="/loading" element={<LoadingScreen/>}/>
            <Route path="/loan-detail" element={<LoanDetail/>}/>
            <Route path="/rpd-polling" element={<RpdPollingScreen/>}/>
            <Route path="/rejected" element={<Rejected/>}/>
            <Route path="/ckyc-otp" element={<CkycOtpInput/>}/>
            <Route path="/vkyc-verification" element={<VkycVerification/>}/>
            <Route path="/disbursal-waiting" element={<DisbursalWaiting/>}/>
            <Route path='*' element={<LoaderScreen />} />
        </Routes>
    );
}

export default AppRouter;
